import React from "react";
import { Card, CardBody } from "@chakra-ui/react";

interface PlanCardProps {
  title: string;
  subtitle: string;
  icon: string;
  className?: string;
  style?: React.CSSProperties;
}

const PlanCard: React.FC<PlanCardProps> = ({
  title,
  subtitle,
  icon,
  className,
  style,
}) => {
  return (
    <Card direction="row" width={"full"} className={className} style={style}>
      <div className="flex items-center justify-center text-xl pl-1 pr-4">
        {icon}
      </div>
      <CardBody className="flex flex-col items-start justify-center text-start py-2">
        <div className="font-semibold text-lg">{title}</div>
        <div className="text-[var(--color-grey)]">{subtitle}</div>
      </CardBody>
    </Card>
  );
};

export default PlanCard;
